import axios from "axios";
import config from "../../../config";

/**
 * Customer portal 2FA — send OTP after mobile + password — POST api/v1/customer-portal/send-otp
 */
export function customerPortalSendOtp(body) {
  return axios.post(`${config.API_URL}customer-portal/send-otp`, body, {
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * Customer portal OTP verify — POST api/v1/customer-portal/verify-otp
 */
export function customerPortalVerifyOtp(body) {
  return axios.post(`${config.API_URL}customer-portal/verify-otp`, body, {
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * Customer portal mobile/password login — POST api/v1/customer-portal/login
 */
export function customerPortalLogin(body) {
  return axios.post(`${config.API_URL}customer-portal/login`, body, {
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * Customer portal registration — POST api/v1/customer-portal/register
 */
export function customerPortalRegister(body) {
  return axios.post(`${config.API_URL}customer-portal/register`, body, {
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * Check if client email/phone already exists — POST api/v1/customer-portal/check-registration
 */
export function customerPortalCheckRegistration(body) {
  return axios.post(`${config.API_URL}customer-portal/check-registration`, body, {
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * Customer portal Facebook register/login — POST api/v1/customer-portal/facebook-register
 */
export function customerPortalFacebookRegister(body) {
  return axios.post(`${config.API_URL}customer-portal/facebook-register`, body, {
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * Customer portal Google register/login — POST api/v1/customer-portal/google-register
 */
export function customerPortalGoogleRegister(body) {
  return axios.post(`${config.API_URL}customer-portal/google-register`, body, {
    headers: { "Content-Type": "application/json" },
  });
}

/**
 * Fetch authenticated client profile — POST api/v1/customer-portal/profile
 */
export function customerPortalProfile(token) {
  return axios.post(
    `${config.API_URL}customer-portal/profile`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
}

/**
 * Customer portal password reset — POST api/v1/customer-portal/forgot-password
 */
export function customerPortalForgotPassword(body) {
  return axios.post(`${config.API_URL}customer-portal/forgot-password`, body, {
    headers: { "Content-Type": "application/json" },
  });
}

export function customerPortalLogout(token, auth_key) {
  return axios.post(
    `${config.API_URL}afterlogin/logout`,
    { action: "logout", auth_key },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
}
